export const DownloadInfoImgItem = [
  {
    type: "mac",
    title: "Mac OS",
    hint: "Download the CE version",
    isEnabled: true,
    icon: "icon-a-apple-fill1",
    resource: [
      {
        platform: "mac_arm",
        url: "https://fellou.s3.us-west-1.amazonaws.com/FellouPC/mac/Fellou-CE-1.0.12-2.5.12-2025-09-29-1902-arm64.dmg",
        text: "Apple version",
        overlayTitle: "Apple version",
        icon: "icon-a-apple-fill1",
        version: "2.5.12",
      },
      {
        platform: "mac_intel",
        url: "https://fellou.s3.us-west-1.amazonaws.com/FellouPC/mac/Fellou-CE-1.0.12-2.5.12-2025-09-29-1902-x64.dmg",
        text: "Intel version",
        overlayTitle: "Intel version",
        icon: "icon-a-apple-fill1",
        version: "2.5.12",
      },
    ],
  },
  {
    type: "windows",
    title: "Windows",
    hint: "Download the CE version",
    isEnabled: false,
    icon: "icon-windows_fill",
    resource: [
      {
        platform: "windows",
        url: "https://fellou.s3.us-west-1.amazonaws.com/FellouPC/windows/Fellou-CE-2.5.12.exe",
        text: "Windows version",
        overlayTitle: "Windows version",
        icon: "icon-a-apple-fill1",
        version: "2.5.12",
      },
    ],
  },
];
